<template>
  <div class="m-footer-links">
    <div class="foot-link-hd m-width">
      <div class="links-col">
        <h2>关于我们</h2>
        <div class="links-list">
          <ul>
            <li>
              <router-link :to="{name:'aboutUs'}">关于我们</router-link>
            </li>
            <li>
              <router-link :to="{name:'contactUs'}">联系我们</router-link>
            </li>
            <li>
              <a href>商务合作</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="links-col">
        <h2>关注我们</h2>
        <div class="links-list">
          <ul>
            <li>
              <a target="_blank"
                 href="https://weibo.com/p/1006066829964030/home?from=page_100606&mod=TAB&is_hot=1">新浪微博</a>
            </li>
            <li>
              <a target="_blank"
                 href="https://www.toutiao.com/c/user/5849703835/#mid=1608826122136579">今日头条</a>
            </li>
            <li>
              <a target="_blank"
                 href="http://dy.163.com/v2/article/detail/EBPAOSFP0545571Q.html">网易自媒体</a>
            </li>
            <li>
              <a target="_blank"
                 href="https://www.zhihu.com/org/dui-lu-yun/posts">知乎平台</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="links-col">
        <h2>友情链接</h2>
        <div class="links-list">
          <ul>
            <li v-for="(item,index) in footData"
                :key="index">
              <a target="_blank"
                 :href="item.outLink">{{item.Title}}</a>
            </li>

          </ul>
        </div>
      </div>
      <div class="links-code">
        <div class="links-code-pic">
          <img :src="require('../../html/components/footer/images/code.png')"
               alt>
        </div>
        <div class="links-code-txt">
          <p>扫描二维码</p>
          <p>关注堆绿公众号</p>
        </div>
        <i class="fly-icon"></i>
      </div>
    </div>
    <div class="footer-copyright">
      <span class="m-width"
            @click="change">2017 堆绿网 Copyright www.duilv.com All rights reserved | 苏ICP备15052781号
        <span id="szgs_stat_icon_54657">
          <a href="http://www.beian.suzhou.gov.cn/websiteMark?siteid=54657&amp;type=1"
             target="_blank">
            <img src="http://www.beian.suzhou.gov.cn/resources/images/marker/szicbok.gif"
                 style="width: 15px;height: 15px;margin-left: 3px;">
          </a>
        </span>
      </span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'h-footer',
  props: {
    footData: Array
  },
  methods: {
    change () {
      // window.open("http://www.beian.miit.gov.cn","_blank");
      // var szgs_protocol = (("https:" == document.location.protocol) ? "https://" : "http://");
      // document.write(unescape("%3C/script%3E%3Cspan id='szgs_stat_icon_54657'%3E%3C/span%3E%3Cscript src='"+szgs_protocol+"www.beian.suzhou.gov.cn/sendMark?siteid=54657&type=1' type='text/javascript'%3E%3C/script%3E"));
    }
  }
};
</script>

<style>
</style>
